import AppAdminTable from "components/AppAdminTable/AppAdminTable";
import { useGetReturns } from "hooks/useGetReturns";
import { Link } from "react-router-dom";
import { toCurrencyFormat } from "helpers/utils";
import { toDate } from "helpers/dateHelper";

const listConfig = [
  {
    key: "id",
    label: "ID",
    render: (item: any) => (
      <Link className="color-blue" to={`/superadmin/marketplace/returns/view/${item.id}`}>
        {item.id}
      </Link>
    ),
  },
  {
    key: "seller",
    label: "Продавец",
    render: (item: any) => (
      <Link className="color-blue" to={`/superadmin/users/view/${item.seller?.id}`}>
        {item.seller?.name}
      </Link>
    ),
  },
  {
    key: "user",
    label: "Покупатель",
    render: (item: any) => (
      <Link className="color-blue" to={`/superadmin/users/view/${item.user?.id}`}>
        {item.user?.lastName} {item.user?.firstName}
      </Link>
    ),
  },
  {
    key: "order",
    label: "Связанный заказ",
    render: (item: any) => (
      <Link className="color-blue" to={`/admin/products/sub-orders/view/${item.subOrderID}`}>
        {item.subOrderID}
      </Link>
    ),
  },
  {
    key: "returnItems",
    label: "Товары",
    render: (item: any) =>
      item.returnItems
        ?.map(
          (orderItem: any) =>
            `${orderItem.name} - (${orderItem.quantity} шт.) - ` +
            `Причина возврата: ${orderItem.reasonType}`
        )
        .join(", "),
  },
  {
    key: "refundStatus",
    label: "Статус возврата",
  },
  {
    key: "totalAmount",
    label: "Сумма возврата",
    render: (item: any) => toCurrencyFormat(item.totalAmount),
  },
  {
    key: "createdAt",
    label: "Дата создания",
    formatter: (v: string) => toDate(v),
  },
];

export const ReturnList = () => {
  const { data, isLoading, error } = useGetReturns();
  if (isLoading) return <div>Загрузка...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <>
      <h2 className="m-b-16">Возвраты</h2>
      <AppAdminTable
        columnConfig={listConfig}
        data={data}
        loading={isLoading}
        onDelete={() => {}}
      />
    </>
  );
};
